/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NexonLwBurnHistoryInfo } from '../models/NexonLwBurnHistoryInfo';
import type { NexonLwBurnHistoryRequest } from '../models/NexonLwBurnHistoryRequest';
import type { NexonLwBurnOverviewInfo } from '../models/NexonLwBurnOverviewInfo';
import type { NexonLwBurnOverviewRequest } from '../models/NexonLwBurnOverviewRequest';
import type { NexonLwCirculatingSupplyBreakdownInfo } from '../models/NexonLwCirculatingSupplyBreakdownInfo';
import type { NexonLwCirculatingSupplyBreakdownRequest } from '../models/NexonLwCirculatingSupplyBreakdownRequest';
import type { NexonLwCirculatingSupplyTrackerInfo } from '../models/NexonLwCirculatingSupplyTrackerInfo';
import type { NexonLwCirculatingSupplyTrackerRequest } from '../models/NexonLwCirculatingSupplyTrackerRequest';
import type { NexonLwOverviewInfo } from '../models/NexonLwOverviewInfo';
import type { NexonLwOverviewRequest } from '../models/NexonLwOverviewRequest';
import type { NexonLwScheduledSupplyInfo } from '../models/NexonLwScheduledSupplyInfo';
import type { NexonLwScheduledSupplyRequest } from '../models/NexonLwScheduledSupplyRequest';
import type { NexonLwScheduledSupplyTrackerInfo } from '../models/NexonLwScheduledSupplyTrackerInfo';
import type { NexonLwScheduledSupplyTrackerRequest } from '../models/NexonLwScheduledSupplyTrackerRequest';
import type { NexonLwTotalSupplyBreakdownInfo } from '../models/NexonLwTotalSupplyBreakdownInfo';
import type { NexonLwTotalSupplyBreakdownRequest } from '../models/NexonLwTotalSupplyBreakdownRequest';
import type { NexonLwWalletBalanceTrackerInfo } from '../models/NexonLwWalletBalanceTrackerInfo';
import type { NexonLwWalletBalanceTrackerRequest } from '../models/NexonLwWalletBalanceTrackerRequest';
import type { NexonLwWeeklyBurnSourcesInfo } from '../models/NexonLwWeeklyBurnSourcesInfo';
import type { NexonLwWeeklyBurnSourcesRequest } from '../models/NexonLwWeeklyBurnSourcesRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class LwControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTotalSupplyBreakdown({
        requestBody,
    }: {
        requestBody: NexonLwTotalSupplyBreakdownRequest,
    }): CancelablePromise<NexonLwTotalSupplyBreakdownInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/livewatch/supply/total/breakdown',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getScheduledSupplyTracker({
        requestBody,
    }: {
        requestBody: NexonLwScheduledSupplyTrackerRequest,
    }): CancelablePromise<NexonLwScheduledSupplyTrackerInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/livewatch/supply/scheduled/tracker',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getScheduledSupplyDonut({
        requestBody,
    }: {
        requestBody: NexonLwScheduledSupplyRequest,
    }): CancelablePromise<NexonLwScheduledSupplyInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/livewatch/supply/scheduled/donut',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCirculatingSupplyTracker({
        requestBody,
    }: {
        requestBody: NexonLwCirculatingSupplyTrackerRequest,
    }): CancelablePromise<NexonLwCirculatingSupplyTrackerInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/livewatch/supply/circulating/tracker',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getOverview({
        requestBody,
    }: {
        requestBody: NexonLwOverviewRequest,
    }): CancelablePromise<NexonLwOverviewInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/livewatch/overview',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getWeeklyBurnSources({
        requestBody,
    }: {
        requestBody: NexonLwWeeklyBurnSourcesRequest,
    }): CancelablePromise<NexonLwWeeklyBurnSourcesInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/livewatch/burn/weekly/sources',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBurnOverview({
        requestBody,
    }: {
        requestBody: NexonLwBurnOverviewRequest,
    }): CancelablePromise<NexonLwBurnOverviewInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/livewatch/burn/overview',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBurnHistoryList({
        requestBody,
    }: {
        requestBody: NexonLwBurnHistoryRequest,
    }): CancelablePromise<NexonLwBurnHistoryInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/livewatch/burn/history/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCirculatingSupplyBreakdown({
        requestBody,
    }: {
        requestBody: NexonLwCirculatingSupplyBreakdownRequest,
    }): CancelablePromise<NexonLwCirculatingSupplyBreakdownInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/livewatch/burn/circulating/supply/breakdown',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getWalletBalanceTracker({
        requestBody,
    }: {
        requestBody: NexonLwWalletBalanceTrackerRequest,
    }): CancelablePromise<NexonLwWalletBalanceTrackerInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/livewatch/balance/wallet/tracker',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
